import styled from 'styled-components';

export const WrapperForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .linha-superior,
  .linha-inferior {
    display: flex;
    gap: 1rem;
    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .linha-superior > * {
    flex: 1 1 0;
    min-width: 160px;
  }

  .linha-inferior {
    align-items: flex-start;
    display: flex;
  }

  .multi-expand {
    flex: 1 1 auto;
  }

  .bico {
    width: 200px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .row-botoes {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-btween;
  }
`;
